export const buyWineWinesFiltersKey = {
  countryFilter: 'wine.country',
  producerFilter: 'wine.tradeName',
  wineTypeFilter: 'wine.wineType',
  wineColourFilter: 'wine.wineColor',
  sweetnessTypeFilter: 'wine.sweetnessLevel',
  vintageFilter: 'wine.vintage',
  bottleSizeFilter: 'bottleSize',
  packageTypeFilter: 'packageType',
  grapesFilter: 'grapeAndMonocepage',
  certificatesFilter: 'wine.certification',
  alcoholLevelFilter: 'alcoholOnLabel',
  wwlRatingFilter: 'wine.rating',
  nationalGITypeFilter: 'wine.nationalGIType',
  geoIndicationFilter: 'wine.geoIndication',
  brandFilter: 'wine.brand',
  specialClassificationFilter: 'wine.specialClassification',
  rankFilter: 'appellationRating.rank',
  showLatestVintageFilter: 'onlyLatestVintage',
  marginFilter: 'margin',
  bestOfferPriceFilter: 'bestOfferPricePerBottle',
  coefFilter: 'coef',
  minRetailPriceFilter: 'minRetailPrice',
  recommendedRetailPriceFilter: 'recommendedRetailPrice',
  hasBottleImageFilter: 'hasBottleImage',
  hasFrontLabelImageFilter: 'hasFrontLabelImage',
  hasBackLabelImageFilter: 'hasBackLabelImage',
  hasVerifiedRepresentativeFilter: 'hasVerifiedRepresentative',
  havePublicReviewsFilter: 'havePublicPublishedReviews',
  monocepageFilter: 'grapeAndMonocepage.monocepage',
}
